import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchAttachContrato = async (numeroEmpleado, body, token) => {
  const method = "POST";
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const res = await ApiRequestInterceptor(
    USERS.attachContrato(numeroEmpleado),
    method,
    body,           // { key, filename }
    headers
  );

  const status = res.status ?? res.code;
  if (status >= 200 && status < 300) return res.data;

  throw new Error(res?.data?.error || "No se pudo adjuntar el contrato");
};